import cloneDeepWith from 'lodash/cloneDeepWith';

export function trimFilterValues<T>(values: T): T {
  return cloneDeepWith(values, (value) => (typeof value === 'string' ? value.trim() : undefined));
}
